import DeleteIcon from "@mui/icons-material/Delete";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import deleteReserve from "@/features/reserves/api/deleteReserve";
import { RDialog } from "@/shared/components/forms";

type DeleteReserveButtonProps = {
  reserveId: string;
  refetchReserve: () => void;
};

export default function DeleteReserveButton({
  reserveId,
  refetchReserve,
}: DeleteReserveButtonProps) {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleDeleteReserve = async () => {
    try {
      await deleteReserve(reserveId);
      refetchReserve();
    } catch (error) {
      // @todo deal with error
    }
    handleClose();
  };

  return (
    <>
      <MenuItem key="delete" onClick={handleOpen}>
        <DeleteIcon fontSize="small" />
      </MenuItem>
      <RDialog
        isOpen={isModalOpen}
        title="Delete Selected Reserve"
        cancelButtonCallback={handleClose}
        confirmButtonCallback={handleDeleteReserve}
        confirmButtonText="Delete"
        confirmButtonType="error"
        size="small">
        <Typography variant="h5" sx={{ textAlign: "center" }}>
          Are you sure you want to delete the selected reserve?
        </Typography>
      </RDialog>
    </>
  );
}
